import { runUrgentMessageService } from './urgentMessageService';

/**
 * خدمة المجدول لتشغيل المهام الدورية
 */
class SchedulerService {
  private urgentMessageInterval: NodeJS.Timeout | null = null;
  private isRunning = false;

  /**
   * بدء تشغيل المجدول
   */
  start(): void {
    if (this.isRunning) {
      console.log('Scheduler is already running');
      return;
    }

    console.log('Starting scheduler service...');
    this.isRunning = true;

    // تشغيل رسائل الاستعجال كل 6 ساعات (6 * 60 * 60 * 1000 = 21600000 مللي ثانية)
    this.urgentMessageInterval = setInterval(async () => {
      try {
        console.log('Running scheduled urgent message service...');
        await runUrgentMessageService();
      } catch (error) {
        console.error('Error in scheduled urgent message service:', error);
      }
    }, 6 * 60 * 60 * 1000); // كل 6 ساعات

    // تشغيل أول مرة بعد دقيقة واحدة من بدء التشغيل
    setTimeout(async () => {
      try {
        console.log('Running initial urgent message service...');
        await runUrgentMessageService();
      } catch (error) {
        console.error('Error in initial urgent message service:', error);
      }
    }, 60 * 1000); // بعد دقيقة واحدة

    console.log('Scheduler service started successfully');
  }

  /**
   * إيقاف تشغيل المجدول
   */
  stop(): void {
    if (!this.isRunning) {
      console.log('Scheduler is not running');
      return;
    }

    console.log('Stopping scheduler service...');

    if (this.urgentMessageInterval) {
      clearInterval(this.urgentMessageInterval);
      this.urgentMessageInterval = null;
    }

    this.isRunning = false;
    console.log('Scheduler service stopped');
  }

  /**
   * التحقق من حالة تشغيل المجدول
   */
  isSchedulerRunning(): boolean {
    return this.isRunning;
  }

  /**
   * تشغيل يدوي لخدمة رسائل الاستعجال
   */
  async runUrgentMessagesNow(): Promise<void> {
    try {
      console.log('Running urgent message service manually...');
      await runUrgentMessageService();
    } catch (error) {
      console.error('Error running urgent message service manually:', error);
      throw error;
    }
  }
}

// إنشاء مثيل واحد من الخدمة
const schedulerService = new SchedulerService();

export default schedulerService;

/**
 * بدء تشغيل المجدول (يتم استدعاؤها عند تحميل التطبيق)
 */
export const startScheduler = (): void => {
  schedulerService.start();
};

/**
 * إيقاف تشغيل المجدول
 */
export const stopScheduler = (): void => {
  schedulerService.stop();
};

/**
 * التحقق من حالة المجدول
 */
export const isSchedulerRunning = (): boolean => {
  return schedulerService.isSchedulerRunning();
};

/**
 * تشغيل يدوي لخدمة رسائل الاستعجال
 */
export const runUrgentMessagesManually = async (): Promise<void> => {
  return schedulerService.runUrgentMessagesNow();
};
